import { useMemo } from 'react';
import { VacationDpDecisionPanel } from '@/features/Vacations/components/VacationDpDecisionModal/VacationDpDecisionPanel';
import { buildDpDecisionDemo } from './dpDecisionDemo.definitions';

const noop = () => {};

export function TourDemoDpDecision() {
    const { row, request, allRows } = useMemo(() => buildDpDecisionDemo(new Date()), []);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
            <div
                data-tour="dp-decision-demo"
                className="flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl"
            >
                <VacationDpDecisionPanel
                    row={row}
                    request={request}
                    allRows={allRows}
                    titleId="tour-demo-dp-decision-title"
                    isSubmitting={false}
                    isOwnRequest={false}
                    onClose={noop}
                    onConfirm={noop}
                    historyEvents={[]}
                />
            </div>
        </div>
    );
}

export default TourDemoDpDecision;
